// import {
// 	createRouter,
// 	createWebHashHistory
// } from "vue-router";

// const routes = [
// 	{
// 		path: '/',
// 		name: 'index',
// 		component: () => import('../components/index.vue')
// 	},
// 	{
// 		path: '/pool',
// 		name: 'pool',
// 		component: () => import('../components/pool.vue')
// 	},
// 	{
// 		path: '/exchange',
// 		name: 'exchange',
// 		component: () => import('../components/exchange.vue')
// 	},
// 	{
// 		path: '/account',
// 		name: 'account',
// 		component: () => import('../components/account.vue')
// 	},
// 	{
// 		path: '/record',
// 		name: 'record',
// 		component: () => import('../components/record.vue')
// 	},
// 	{
// 		path: '/team',
// 		name: 'team',
// 		component: () => import('../components/team.vue')
// 	},

// ]

// const router = createRouter({
// 	history: createWebHashHistory(),
// 	routes
// })

// export default router



import {
	createMemoryHistory,
	createRouter,
	createWebHashHistory
} from 'vue-router'

import Index from '../components/index.vue'
import pool from '../components/pool.vue'
import exchange from '../components/exchange.vue'
import account from '../components/account.vue'
import record from '../components/record.vue'
import team from '../components/team.vue'

const routes = [{
		path: '/',
		component: Index
	},
	{
		path: '/pool',
		component: pool
	},
	{
		path: '/exchange',
		component: exchange
	},
	{
		path: '/account',
		component: account
	},
	{
		path: '/record',
		component: record
	},
	{
		path: '/team',
		component: team
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
})

 export default router